import 'Styles/breadcrumb.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import rawToReact from 'Utils/bbcode/RawToReact';
import { pathToForum, pathToForumsIndex } from 'Utils/nav/NavHelpers';
import { resetInfinite } from 'Actions/InfiniteScrollActions'
import { resetForum } from 'Actions/ForumviewActions';
import { trackGAEvent } from 'Actions/adsActions';

import metaSelector from 'Selectors/metaSelector';

class BreadcrumbComponent extends React.Component {
	constructor(props) {
		super(props);

		this.step = 15;
		this.scroll = 0;
		this.scrollTimer = null;
		this.bcContainer = null;
	}

	componentDidMount() {
		this.scrollToLastElement();
	}

	shouldComponentUpdate( nextProps ) {
		// very rarely we'll update it
		return !isEqual( nextProps.path, this.props.path );
	}

	componentDidUpdate() {
		this.scrollToLastElement();
	}

	componentWillUnmount() {
		cancelAnimationFrame( this.scrollTimer );
	}

	scrollToLastElement = () => {
		// get last element and container
		let lastItem = document.querySelectorAll( '#breadCrumbBar li:last-of-type' );

		if( this.bcContainer && lastItem && lastItem.length > 0 ) {
			this.scroll = parseInt( lastItem[ 0 ].getBoundingClientRect().left );

			this.scrollTimer = requestAnimationFrame( () => { this.scrollTo() } );
		}
	};

	scrollTo() {
		if( this.scroll > 0 ) {
			this.scroll -= this.step;
			if( this.bcContainer ) {
				this.bcContainer.scrollLeft += this.step;
			}
			this.scrollTimer = requestAnimationFrame( () => { this.scrollTo() } );
		} else {
			this.scroll = 0;
		}
	}

	gotoIndex = () => {
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetForum() );
		this.props.dispatch( push( pathToForumsIndex() ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'breadCrumb', 'uiAction', 'tap') );
	};

	gotoForum = ( id ) => {
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetForum() );
		this.props.dispatch( push( pathToForum( id ) ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'breadCrumb', 'uiAction', 'tap') );
	};

	render() {
		let {path} = this.props;
		path = path ? path : []; // prevents error when path is empty

		const reversedPath = (
			this.props.routeParams.forumId &&
			path.length > 0 &&
			parseInt( this.props.routeParams.forumId ) === parseInt( path[0].id ) ?
				[...path].splice(1) : [...path]
		).reverse(); // if we are in the subforum don't show it on the breadcrumb

		const pathComponents = reversedPath.map(
			(p, i) => <li key={ i } className="item">
				<span onClick={ () => this.gotoForum(p.id) }>{ rawToReact(p.title) }</span>
			</li>
		);

		return (
			<div key="breadcrumb" id="breadCrumbBar" className="bcContainer nolinks" ref={ (bc) => this.bcContainer = bc } >
				<ul>
					<li className="item">
						<span onClick={ this.gotoIndex }>Index</span>
					</li>
					{ pathComponents }
				</ul>
			</div>
		);
	}
}

BreadcrumbComponent.displayName = 'BreadcrumbComponent';
BreadcrumbComponent.defaultProps = {
	scrollOptions: {
		eventPassthrough: true,
		scrollX: true,
		scrollY: false,
		preventDefault: false
	}
};

BreadcrumbComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	routeParams: PropTypes.object.isRequired,
};

export default connect( metaSelector )( BreadcrumbComponent );



// WEBPACK FOOTER //
// ./src/components/common/BreadcrumbComponent.js